import React from 'react';

import { QuantityInput } from '../QuantityInput';

type Props = {
  onChange: (value: number) => void;
  value: number;
};

export const PricingFormQuantity = ({ onChange, value }: Props) => {
  return <QuantityInput allowZero onChange={onChange} value={value} maxValue={999} />;
};
